module.exports = __webpack_public_path__ + "83ae3de2293a286f1d9760f70b485091.svg";